import { Link } from 'react-router-dom'

function DashboardCard({
  title,
  description,
  to,
  cta,
}: {
  title: string
  description: string
  to: string
  cta: string
}) {
  return (
    <Link to={to} className="block rounded-xl border border-gray-200 bg-white p-5 hover:border-blue-300 hover:shadow-sm transition">
      <h2 className="text-base font-semibold text-gray-900">{title}</h2>
      <p className="mt-2 text-sm text-gray-600">{description}</p>
      <div className="mt-4 text-sm font-semibold text-blue-700">{cta} {'->'}</div>
    </Link>
  )
}

export default function CarrierDashboardPage() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Carrier Command Center</h1>
        <p className="text-sm text-gray-500">Manage fleet operations, loads, and drivers from one role-focused entry point.</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <DashboardCard
          title="Carrier Load Board"
          description="Accept, monitor, and manage carrier-assigned loads."
          to="/carrier/loads"
          cta="Open carrier loads"
        />
        <DashboardCard
          title="Driver Roster"
          description="Update compliance details, assignments, and contact records."
          to="/carrier/drivers"
          cta="Manage drivers"
        />
        <DashboardCard
          title="Fleet Equipment"
          description="Maintain tractors, trailers, and available combinations."
          to="/carrier/equipment"
          cta="Open equipment"
        />
      </div>
    </div>
  )
}
